import styled from "styled-components";

export const SelectTabsContainer = styled.div`
  .ant-tabs {
    margin-top: 2rem;
    margin-bottom: 1.5rem;
    overflow: initial; // added to show select dropdown in investment rae forms
    .ant-tabs-bar {
      display: flex;
      align-items: center;
      border-bottom: none;
      .ant-tabs-extra-content {
        font-size: 16px;
        line-height: 24px;
        color: ${props => props.theme.fontColors.textColor};
        font-family: ${props => props.theme.fontFamily.helveticaNeue};
        margin-bottom: 6px;
      }
      .ant-tabs-nav-container {
        font-size: ${props => props.theme.fontSize.secondary};
        height: auto;
        margin-left: 1.25rem;
        .ant-tabs-nav {
          & > div {
            display: flex;
            font-family: ${props => props.theme.fontFamily.helveticaNeueBold};
            align-items: center;
            .ant-tabs-tab:first-child {
              margin-left: 1px;
            }
            .ant-tabs-tab {
              display:flex;
              align-items:center;
              background-color: #ffffff;
              margin-right: 0;
              padding-top: 0.55rem;
              padding-left: 20px;
              padding-right: 20px;
              padding-bottom: 0.55rem;
              border-radius: 0;
              border: 1px solid ${props => props.theme.border.filledTabsInactive};
              line-height: ${props => props.theme.lineHeight.normal};
              transition: none;
              text-align: center;
              font-family: ${props => props.theme.fontFamily.helveticaNeueBold};
              height: 38px!important;
              color: #505050;
              &.ant-tabs-tab-active {
                color: white;
                border: none;
                background-color: ${props => props.theme.backgroundColor.primaryColor};
                height:49px!important;
              }
            }
          }
        }
      }
    }
  }
  @media only screen and (max-width: 991.92px) {
    .ant-tabs {
      .ant-tabs-bar {
        flex-direction: column;
        .ant-tabs-extra-content {
          align-self: flex-start;
          line-height: 21px;
          margin-bottom: 10px;
          font-size: 14px;
        }
        .ant-tabs-nav-container {
          font-size: ${props => props.theme.fontSize.tertiary};
          width: 100%;
          margin-left: 0;
          .ant-tabs-nav {
            width: 100%;
            & > div {
              width: 100%;
              .ant-tabs-tab {
                white-space: initial;
                padding-bottom: 0.28rem;
                height: auto;
                font-family: ${props => props.theme.fontFamily.helveticaNeueBold};
                padding: 2.4px 20px 2.4px 20px;
                flex-basis: 32%;
                text-align: left;
                &.ant-tabs-tab-active {
                  font-size: ${props => props.theme.fontSize.secondary};
                }
              }
            }
          }
        }
      }
    }
  }
`;
